module.exports = __webpack_public_path__ + "img/sld_scb_2_t1_b1_dark.a51697a9.svg";